export default class User {
    public username: string;
    public email: string;
    public name: string;
    public surname: string;
    public password: string;
    public office: number;

    constructor(username: string, email: string, name: string, surname: string, password: string, office: number) {
        this.username = username;
        this.email = email;
        this.name = name;
        this.surname = surname;
        this.password = password;
        this.office = office;
    }
}
